import React, { useRef, useState, useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { globalStream } from 'src/atom/GlobalStream'
import { loadingState } from 'src/atom/LoadingState'
import { useNavigate } from 'react-router-dom'
import { fetchHomePageNotifications } from 'src/services/Notifications/NotificationService'
import { FaFilePdf } from 'react-icons/fa'
import { Loader } from 'src/components/loader'
import Tostify, { showToast } from 'src/utils/Tostify'
import moment from 'moment'

import { CModal, CModalBody, CModalHeader, CModalTitle } from '@coreui/react'

import PropTypes from 'prop-types'
import Footer from 'src/components/Footer'
import LogoHeader from 'src/components/header/LogoHeader'
import { faDisplay } from '@fortawesome/free-solid-svg-icons'
// const ModalComponent = ({ isOpen, onClose, fileName }) => {
//   return (
//     <CModal visible={isOpen} onClose={onClose}>
//       <CModalHeader onClose={onClose}>
//         <CModalTitle>Document Viewer</CModalTitle>
//       </CModalHeader>
//       <CModalBody>
//         <object
//           data={`path-to-your-files/${fileName}`}
//           type="application/pdf"
//           style={{ width: '100%', height: '500px' }}
//         >
//           <p>
//             Your browser does not support PDFs.{' '}
//             <a href={`path-to-your-files/${fileName}`} download>
//               Download the PDF
//             </a>
//             .
//           </p>
//         </object>
//       </CModalBody>
//     </CModal>
//   )
// }

// ModalComponent.propTypes = {
//   isOpen: PropTypes.bool.isRequired,
//   onClose: PropTypes.func.isRequired,
//   fileName: PropTypes.string,
// }

// ModalComponent.defaultProps = {
//   fileName: null,
// }
const Homepage = () => {
  const navigate = useNavigate()
  const [GSteam, setGlobalSteam] = useRecoilState(globalStream)
  const [loader, enableLoader] = useRecoilState(loadingState)
  const [news, setNewsData] = useState([])
  const [notice, setNoticeData] = useState([])
  const [allNotice, setAllNotice] = useState([])
  const [firstNews, setFirstNews] = useState(null)
  const [documents, setDocuments] = useState(null)
  const [visible, setVisible] = useState(false)

  const handleMDButton =  () => {
    setGlobalSteam((prevGlobalSteam) => ({
      ...prevGlobalSteam,
      counsellingName: 'MD',
    }))

    navigate('/RegistrationInstruction')
  }

  const handleMDSButton =  () => {
    setGlobalSteam((prevGlobalSteam) => ({
      ...prevGlobalSteam,
      counsellingName: 'MDS',
    }))
    navigate('/RegistrationInstruction')
  }
  const handlePDECTButton = () => {
    setGlobalSteam((prevGlobalSteam) => ({
      ...prevGlobalSteam,
      counsellingName: 'PGDNB',
    }))

    navigate('/RegistrationInstruction')
  }

  const handleRegisterCandidate = () => {
    navigate('/login')
  }

  const fetchAllNotification = async () => {
    try {
      enableLoader(true)
      const response = await fetchHomePageNotifications()
      if (response.success) {
        setAllNotice(response.body)
        setNewsData(response.body.news)
        setNoticeData(response.body.notice)
        if (response.body.news.length > 0) {
          setFirstNews(response.body.news[0])
        }
      }
    } catch (error) {
    } finally {
      enableLoader(false)
    }
  }

  useEffect(() => {
    fetchAllNotification()
  }, [])

  const handlePreview = async (fileName) => {
    try {
      enableLoader(true)

      // Assuming fileName is a Base64 encoded string, decode it
      const byteCharacters = atob(fileName)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)

      // Create a Blob from the byte array
      const blob = new Blob([byteArray], { type: 'application/pdf' })

      // Create a download link and trigger a click event
      const downloadLink = document.createElement('a')
      downloadLink.href = URL.createObjectURL(blob)
      downloadLink.download = `${fileName.split('.')[0]}.pdf` // Set the download file name
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)

      enableLoader(false)
    } catch (error) {
      showToast(error, 'error')
      enableLoader(false)
    }
  }

  const handleDownload = async (fileName) => {
    try {
      // let extension = fileName.split('.').pop().toLowerCase();
  
      // const byteCharacters = atob(fileName);
      // const byteNumbers = new Array(byteCharacters.length);
      // for (let i = 0; i < byteCharacters.length; i++) {
      //   byteNumbers[i] = byteCharacters.charCodeAt(i);
      // }
      // const byteArray = new Uint8Array(byteNumbers);
      // const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
  
      // const fileURL = URL.createObjectURL(pdfBlob);
  
      // Open the PDF in a new window
      window.open(fileName);
  
      // setDocuments(fileURL);
      // setVisible(true);
      enableLoader(false);
    } catch (error) {
      showToast(error, 'error');
      enableLoader(false);
    }
  };

  return (
    <>
      {loader ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div className="container-fluid" style={{ padding: '10px 20px', paddingBottom: '80px' }}>
          <div className="card">
            <LogoHeader />
          </div>
          <div
            className="mt-2 d-flex justify-content-center align-items-center"
            style={{ fontWeight: 'bold', fontSize: '25px' }}
          >
            Online Application Form For Admission To MD/MS/MDS/Post MBBS DNB/Post Diploma DNB
            Courses 2024-25
            {/* Online Application Form For Admission To MDS Courses 2024-25 */}
          </div>
          <div className="card mx-sm-3 mx-md-5 mt-3">
            <div className="card-body">
              <div className="row">
                <div className="col-12 d-flex justify-content-center align-items-center flex-wrap">
                  <button
                    className="btn btn-success text-white me-2 mb-2"
                    style={{ padding: '15px 30px' }}
                    onClick={handleRegisterCandidate}
                  >
                    Registered Candidate
                  </button>
                  <button
                    className="btn btn-danger text-white me-2 mb-2"
                    style={{ padding: '15px 30px' }}
                    onClick={handleMDButton}
                  >
                    NEET-PG 2024 Registration
                  </button>
                  <button
                    className="btn btn-danger text-white me-2 mb-2"
                    style={{ padding: '15px 30px' }}
                    onClick={handleMDSButton}
                  >
                    NEET-MDS 2024 Registration
                  </button>
                  <button
                    className="btn btn-danger text-white mb-2"
                    style={{ padding: '15px 30px' }}
                    onClick={handlePDECTButton}
                  >
                    PDCET 2024 Registration
                  </button>
                </div>
              </div>

              <div className="row mt-2 mb-2">
                <div className="col-sm-12 " style={{ fontWeight: 'bold', color: 'red' }}>
                  Important Instructions
                </div>
              </div>
              <div className="card" style={{ height: '30%' }}>
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex">
                      <div
                        className="text-container text-white p-1"
                        style={{ background: 'skyblue' }}
                      >
                        Important
                      </div>
                      <div className="moving-container w-100">
                        <span className="moving-text w-100 ms-4">{firstNews?.content}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">News & Updates</div>
                    <div className="card-body">
                      <ul className="list-unstyled">
                        {news?.length > 0 ? (
                          news.map((item) => (
                            <li key={item.id} className="mb-3">
                              <div className="d-flex flex-column">
                                <h6 style={{ color: '#000' }}>{item?.subject}</h6>
                                <span style={{ color: `${item.color}` }}>{item?.content}</span>
                              </div>
                            </li>
                          ))
                        ) : (
                          <li>
                            No News Found
                            {/* <CLoader /> */}
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">Notice Board</div>
                    <div className="card-body">
                      <ul className="list-unstyled">
                        {notice?.length > 0 ? (
                          notice.map((item) => (
                            <li key={item.id} className="mb-3">
                              <div className="d-flex flex-column">
                                <div className="row">
                                  <div className="col-md-6">
                                    <h6 style={{ color: '#000' }}>{item?.subject}</h6>
                                  </div>
                                  <div className="col-md-6">
                                    <p
                                      style={{
                                        fontSize: '12px',
                                        color: 'gray',
                                        marginBottom: '5px',
                                        textAlign: 'right',
                                      }}
                                    >
                                      {item?.publishDate}
                                    </p>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center">
                                  <span style={{ color: `${item.color}` }}>{item?.content}</span>
                                  {item.fileName && (
                                    <button
                                      // onClick={() => handlePreview(item.extension)}
                                      onClick={() => handleDownload(item.extension)}
                                      className="btn btn-link ml-2"
                                    >
                                      <FaFilePdf style={{ fontSize: '24px' }} />
                                    </button>
                                  )}
                                </div>
                              </div>
                            </li>
                          ))
                        ) : (
                          <span>No Notice Found</span>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
    @keyframes moveLeft {
        0% {
            transform: translateX(100%);
        }
        100% {
            transform: translateX(-100%);
        }
    }

    .text-container {
        background: skyblue;
    }

    .moving-container {
        overflow: hidden;
    }

    .moving-text {
        animation: moveLeft 50s linear infinite;
        white-space: nowrap;
        display: inline-block;
        animation-delay: 1s; /* Delay start of animation */
    }
    `}
      </style>
      <CModal scrollable visible={visible} onClose={() => setVisible(false)} size="xl">
        <CModalHeader>
          <CModalTitle>PDF</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="container mt-4">
            <div className="row mb-2">
              <div className="col-md-6">
                <div className="form-group">
                  {documents && (
                    <object
                      data={documents}
                      type="application/pdf"
                      style={{ width: '200%', height: '500px', border: 'none' }}
                    >
                      <p>
                        Your browser does not support viewing PDFs.{" "}
                        <a href={documents} download>
                          Click here to download the PDF
                        </a>
                      </p>
                    </object>
                  )}
                </div>
              </div>
            </div>
          </div>
        </CModalBody>
      </CModal>
      <Tostify />
      <Footer />
    </>
  )
}

export default Homepage
